import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { typeWrapper } from '@cf/core';
import { IAccount } from '../interfaces';
import { AccountStore } from './account.store';

@Injectable({ providedIn: 'root' })
export class AccountQuery extends Query<IAccount> {
  public account$: Observable<IAccount> = this.select((state: IAccount) => state);

  public showCalendarAlert$: Observable<boolean> = this.account$.pipe(
    map(({ showCalendarAlert }: IAccount) => typeWrapper<boolean>(showCalendarAlert)),
  );

  constructor(protected override store: AccountStore) {
    super(store);
  }
}
